import React from "react";
import { Panel, PanelType, Pivot, PivotItem, Stack } from "@fluentui/react";
import { ChatHistoryPanel } from "../../components/ChatHistory/ChatHistoryPanel";
import { RAGMenu } from "../rag/RAGMenuPanel";
import { PromptTemplateMenu, PromptTemplateMenuProps } from "../prompt-template/PromptTemplateMenuPanel";
import { BasicButtonStyle } from "../../components/QuestionInput";

type TabLinkProps = {
    children?: React.ReactNode;
};
const TabLink: React.FC<TabLinkProps> = (props: TabLinkProps) => {
    const {children} = props
    return <div style={{ textAlign: 'center', display: 'inline-block', width: "100%", height: "34px" }}>
        {children}
    </div>
}

export type SideBarState = "PromptTemplate" | "ChatHistory" | "RAG"

interface SideBarTab {
    isRAGAvailable: boolean
    selectedKey: SideBarState
    onTabChange: (key: SideBarState) => void
    promptTemplateMenuProps: PromptTemplateMenuProps
}

const SideBarTab = (props: SideBarTab) => {
    const {isRAGAvailable, selectedKey, onTabChange, promptTemplateMenuProps} = props
    const tabButtonStyle: React.CSSProperties = {
        whiteSpace: 'normal',
        width: '100px',
        minHeight: '52px',
        height: 'auto',
        padding: '6px 8px',
        lineHeight: '1.3',
        fontWeight: '600',
        fontSize: '13px',
    }
    const disabledStyle = {
        cursor: 'not-allowed', 
        opacity: 0.4
    }
    const pivotItemStyle = {
        height: "100%",
        maxHeight: "100%",
        overflow: "hidden"
    }
    // RAGが無効の場合、強制的に変更
    const currentKey = isRAGAvailable || selectedKey !== "RAG" ? selectedKey : "ChatHistory"
    return (
        <Stack style={{width: "330px", height: "100%", padding: "6px 6px 0px 0px", overflow: "hidden"}}>
            <Pivot
                selectedKey={currentKey}
                onLinkClick={(item) => {
                    if (item?.props.itemKey) {
                        onTabChange?.(item.props.itemKey as SideBarState)
                    }
                }}
                styles={{ 
                    itemContainer: { 
                        flexGrow: 1,
                        minHeight: 0,
                        height: "100%",
                        maxHeight: "100%",
                        overflow: 'hidden',
                        userSelect: "none"
                    },
                    link: {
                        borderTop: '1px solid #d2d0ce',
                        borderLeft: '1px solid #d2d0ce',
                        borderRight: '1px solid #d2d0ce',
                        margin: '0 2px',
                        selectors: {
                            ':hover': {
                                background: '#e1dfdd',
                            }
                        }
                    },
                    linkIsSelected: {
                        ...BasicButtonStyle.activeStyle,
                    }
                }}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    maxHeight: "100%",
                    overflow: "hidden"
                }}
            >
                <PivotItem 
                    onRenderItemLink={() => (
                        <TabLink>
                            <br />チャット履歴
                        </TabLink>
                    )}
                    itemKey="ChatHistory" 
                    headerButtonProps={{ style: tabButtonStyle }}
                    style={pivotItemStyle}
                >
                    <ChatHistoryPanel />
                </PivotItem>
                <PivotItem 
                    onRenderItemLink={() => (
                        <TabLink>
                            プロンプト<br />テンプレート
                        </TabLink>
                    )}
                    itemKey="PromptTemplate" 
                    headerButtonProps={{ style: tabButtonStyle }}
                    style={pivotItemStyle}
                >
                    <PromptTemplateMenu {...promptTemplateMenuProps} />
                </PivotItem>
                <PivotItem 
                    onRenderItemLink={() => (
                        <TabLink>
                            文書検索<br />カテゴリ
                        </TabLink>
                    )}
                    itemKey="RAG" 
                    headerButtonProps={{ style: {...tabButtonStyle, ...(!isRAGAvailable && disabledStyle)}, disabled: !isRAGAvailable }}
                    style={pivotItemStyle}
                >
                    <RAGMenu />
                </PivotItem>
            </Pivot>
        </Stack>
    )
}

interface SideBarProps {
    isOpen: boolean
    isOverlay: boolean
    onClose: () => void
    isRAGAvailable: boolean
    selectedKey: SideBarState
    onTabChange: (key: SideBarState) => void
    promptTemplateMenuProps: PromptTemplateMenuProps
}
export const SideBar = (props: SideBarProps) => {
    const {isOpen, isOverlay, onClose, isRAGAvailable, selectedKey, onTabChange, promptTemplateMenuProps} = props
    return (
        isOverlay ? 
        <Panel 
            isLightDismiss
            isOpen={isOpen} 
            onDismiss={onClose} 
            type={PanelType.customNear} 
            customWidth="360px"
            styles={{
                scrollableContent: {
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column"
                },
                content: {
                    flexGrow: 1,
                    minHeight: 0
                }
            }}
        >
            <SideBarTab 
                isRAGAvailable={isRAGAvailable} 
                selectedKey={selectedKey} 
                onTabChange={onTabChange} 
                promptTemplateMenuProps={promptTemplateMenuProps}
            />
        </Panel>
        :
        <div style={{ display: isOpen ? "block" : "none"}}>
            <SideBarTab 
                isRAGAvailable={isRAGAvailable} 
                selectedKey={selectedKey} 
                onTabChange={onTabChange} 
                promptTemplateMenuProps={promptTemplateMenuProps}
            />
        </div>
    )
}